<template>
  <div>
    <v-img v-for="url in urls" :key='url' :src='url' contain></v-img>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
const rec_url = 'https://qr.lemnisoftinc.com/api/file?code='

export default {
  props: ['code'],
  name: 'MenuIMDetail',
  computed: {
    urls(){
      return ['https://qr.lemnisoftinc.com/api/file?code=img25', 'https://qr.lemnisoftinc.com/api/file?code=img25']// + this.code
    }
  },
  methods: {
    ...mapActions(['getFileResource'])
  }
}
</script>
